export default "__VITE_ASSET__btGhPhqq__"